import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted, computed } from './vue.esm-browser.prod.js';
import { soupData, rankData, reportData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger } from './common/k-tools/k-tools.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const swiperHandler = {};
swiperHandler.firstComment = () => {
  let firstCommentSwiper;
  const firstCommentSwiperInit = () => {
    const el = $('.rank__item:first-child .vote-comment-swiper');
    const paginationEl = $(el).find('.swiper-pagination')[0];
    const prevEl = $(el).find('.swiper-button-prev')[0];
    const nextEl = $(el).find('.swiper-button-next')[0];
    firstCommentSwiper = new Swiper(el[0], {
      slidesPerView: 1,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  };

  const checkScreenWidth = () => {
    const viewWidth = window.innerWidth;
    if (viewWidth < 1000) {
      firstCommentSwiperInit();
    } else {
      if (firstCommentSwiper) {
        firstCommentSwiper.destroy(true, true);
        firstCommentSwiper = null;
      }
    }
  };

  checkScreenWidth();
  $(window).on('resize', checkScreenWidth);
};
swiperHandler.comment = () => {
  $('.rank__item:not(:first-child) .vote-comment-swiper').each((index, el) => {
    const paginationEl = $(el).find('.swiper-pagination')[0];
    const prevEl = $(el).find('.swiper-button-prev')[0];
    const nextEl = $(el).find('.swiper-button-next')[0];
    new Swiper(el, {
      loop: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  });
};
swiperHandler.all = () => {
  swiperHandler.firstComment();
  swiperHandler.comment();
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });

  gsapAnimation();
  swiperHandler.all();
};

// Vue
createApp({
  setup() {
    const rankedSoupData = computed(() => {
      return rankData.map(item => {
        const soup = soupData.find(s => s.name === item.name);
        return soup ? { ...item, ...soup } : item;
      });
    });
    const reportDataRef = ref(reportData);
    const avatars = [
      './assets/img/man1.svg',
      './assets/img/man2.svg',
      './assets/img/man3.svg',
      './assets/img/woman1.svg',
      './assets/img/woman2.svg',
      './assets/img/woman3.svg',
    ];

    // 取得隨機不重複頭像清單
    function getRandomAvatars(count) {
      const shuffled = [...avatars].sort(() => Math.random() - 0.5);
      return Array.from({ length: count }, (_, i) => shuffled[i % shuffled.length]);
    }
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      rankedSoupData,
      reportDataRef,
      getRandomAvatars,
    };
  },
}).mount('#main');
